import React from 'react';
import PropTypes from 'prop-types';

import {makeStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';


const useStyles = makeStyles(theme => ({
  root: {
    height: '12px',
    borderRadius: '50px'
  },
  colorPrimary: {
    backgroundColor: theme.palette.common.paleGrey,
  },
  barColorPrimary: {
    backgroundColor: theme.palette.common.tealish,
  },
}));

const ProgressBar = ({ value=0 }) => {
  const classes = useStyles();
  return (
    <LinearProgress
      classes={
        {
          root: classes.root,
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary
        }
      }
      variant="determinate"
      value={value}
    />
  );
};

ProgressBar.propTypes = {
  value: PropTypes.number,
};

export default ProgressBar;